/**
 * UserContact 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserContact
 */
export interface UserContact {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 手机号E.164格式 */
  phone?: string
  /** 手机号国家代码 */
  phone_dial_code?: string
  /** 手机号国内号码 */
  phone_national_number?: string
  /** 手机号绑定时间 */
  phone_bound_at?: string
  /** 邮箱地址 */
  email?: string
  /** 邮箱绑定时间 */
  email_bound_at?: string
  /** 上一个手机号（用于恢复） */
  last_phone?: string
  /** 上一个邮箱（用于恢复） */
  last_email?: string
}

/**
 * UserContact Schema
 */
export const UserContactSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    phone: {
      description: '手机号E.164格式',
      format: 'string',
      type: 'string',
      label: '手机号E.164格式',
    },
    phone_dial_code: {
      description: '手机号国家代码',
      format: 'string',
      type: 'string',
      label: '手机号国家代码',
    },
    phone_national_number: {
      description: '手机号国内号码',
      format: 'string',
      type: 'string',
      label: '手机号国内号码',
    },
    phone_bound_at: {
      description: '手机号绑定时间',
      format: '*time.Time',
      type: 'string',
      label: '手机号绑定时间',
    },
    email: {
      description: '邮箱地址',
      format: 'string',
      type: 'string',
      label: '邮箱地址',
    },
    email_bound_at: {
      description: '邮箱绑定时间',
      format: '*time.Time',
      type: 'string',
      label: '邮箱绑定时间',
    },
    last_phone: {
      description: '上一个手机号（用于恢复）',
      format: 'string',
      type: 'string',
      label: '上一个手机号',
    },
    last_email: {
      description: '上一个邮箱（用于恢复）',
      format: 'string',
      type: 'string',
      label: '上一个邮箱',
    },
  },
  type: 'object',
}
